export default "__VITE_ASSET__3zQ8LnVA__"